import React from 'react'

const ReserveAnHourSection = () => {
    return (
        <div className="reserve-an-hour-section">
            <ul>
                <li>
                    <a href={`/${document.body.dataset.site}/psicologos`}>Busca un psicólogo</a>
                </li>
                <li>
                    <a href={`/${document.body.dataset.site}/users/sign_up`}>Regístrate en Terapi</a>
                </li>
                <li>
                    <a href={`/${document.body.dataset.site}/users/sign_in`}>Ingresa a Terapi</a>
                </li>
                <li>
                    <a href={`mailto:contacto@terapi-app.com`}>Ponte en contacto</a>
                </li>
            </ul>

        </div>
    )
}

export default ReserveAnHourSection
